import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./styles/Navigation.css";

import logo from "../Components/Navigation logo/suryanirbhar_icon.png";

const Navigation = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  /* NAVBAR SCROLL EFFECT */
  useEffect(() => {

    const handleScroll = () => {

      const navbar =
        document.querySelector(".navbar");

      if (window.scrollY > 50) {

        navbar.classList.add(
          "scrolled"
        );

      } else {

        navbar.classList.remove(
          "scrolled"
        );

      }

    };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );

  }, []);

  /* SCROLL TO TOP */
  const scrollToTop = () => {

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });

    setMenuOpen(false);

  };

  return (

    <nav className="navbar">

      {/* LOGO */}
      <div className="nav-left">

        <img
          src={logo}
          alt="logo"
          className="logo-img"
        />

        <span className="logo-text">
          Suryanirbhar Agritech
        </span>

      </div>

      {/* MENU ICON */}
      <div
        className="menu-icon"
        onClick={() =>
          setMenuOpen(!menuOpen)
        }
      >
        ☰
      </div>

      {/* NAV LINKS */}
      <ul
        className={
          menuOpen
            ? "nav-links active"
            : "nav-links"
        }
      >

        <li>
          <Link
            to="/"
            onClick={scrollToTop}
          >
            Home
          </Link>
        </li>

        <li>
          <Link
            to="/about"
            onClick={scrollToTop}
          >
            About
          </Link>
        </li>

        {/* PRODUCTS */}
        <li>
          <Link
            to="/products"
            onClick={scrollToTop}
          >
            Products
          </Link>
        </li>

        {/* TESTIMONIALS */}
        <li>
          <Link
            to="/testimonials"
            onClick={scrollToTop}
          >
            Testimonials
          </Link>
        </li>

        {/* MEDIA DROPDOWN */}
        <li className="dropdown">

          <span className="media-pill">
            Media
            <span className="arrow">
              ▼
            </span>
          </span>

          <ul className="dropdown-menu">

            <li>
              <Link
                to="/photo-gallery"
                onClick={scrollToTop}
              >
                Photo Gallery
              </Link>
            </li>

            <li>
              <Link
                to="/video-gallery"
                onClick={scrollToTop}
              >
                Videos
              </Link>
            </li>

            <li>
              <Link
                to="/news"
                onClick={scrollToTop}
              >
                In News
              </Link>
            </li>

            <li>
              <Link
                to="/events"
                onClick={scrollToTop}
              >
                Events
              </Link>
            </li>

            <li>
              <Link
                to="/product-catalog"
                onClick={scrollToTop}
              >
                Product Catalog
              </Link>
            </li>

          </ul>

        </li>

        {/* BLOG */}
        <li>
          <Link
            to="/blog"
            onClick={scrollToTop}
          >
            Newsletter
          </Link>
        </li>

        {/* CONTACT */}
        <li>
          <Link
            to="/contact"
            onClick={scrollToTop}
          >
            Contact Us
          </Link>
        </li>

      </ul>

    </nav>

  );

};

export default Navigation;